import { FSM_STAGES } from "@/lib/domains";
import { Check } from "lucide-react";

export const ProcessFSM = ({ fsmIndex, quarantine }) => {
  return (
    <div className="glass-panel rounded-2xl p-5 h-full flex flex-col">
      <div className="flex items-center justify-between mb-4">
        <h3 className="mono text-xs font-semibold uppercase tracking-widest text-cyan-400">
          Process State · FSM
        </h3>
        <span
          className="mono text-[10px] font-semibold px-2 py-0.5 rounded"
          style={{
            color: quarantine ? "#fca5a5" : FSM_STAGES[fsmIndex].color,
            backgroundColor: quarantine ? "rgba(127,29,29,0.4)" : `${FSM_STAGES[fsmIndex].color}22`,
          }}
        >
          {quarantine ? "HALTED" : FSM_STAGES[fsmIndex].key.toUpperCase()}
        </span>
      </div>
      <div className="flex-1 flex flex-col justify-center gap-2.5">
        {FSM_STAGES.map((stage, i) => {
          const done = i < fsmIndex;
          const active = i === fsmIndex && !quarantine;
          return (
            <div
              key={stage.key}
              data-testid={stage.testid}
              className={`flex items-center gap-3 rounded-lg border px-3 py-2.5 transition-all ${
                active
                  ? "border-transparent"
                  : "border-slate-800 bg-slate-900/40"
              }`}
              style={
                active
                  ? {
                      backgroundColor: `${stage.color}18`,
                      borderColor: `${stage.color}66`,
                      boxShadow: `0 0 16px -4px ${stage.color}66`,
                    }
                  : {}
              }
            >
              <div
                className="h-6 w-6 rounded-full flex items-center justify-center mono text-[11px] font-bold shrink-0"
                style={{
                  backgroundColor: done || active ? stage.color : "#1e293b",
                  color: done || active ? "#060A12" : "#64748b",
                }}
              >
                {done ? <Check className="h-3.5 w-3.5" /> : i + 1}
              </div>
              <span
                className={`mono text-sm font-medium ${
                  active ? "text-slate-100" : done ? "text-slate-400" : "text-slate-500"
                }`}
              >
                {stage.key}
              </span>
              {active && (
                <span className="ml-auto beacon h-2 w-2 rounded-full" style={{ backgroundColor: stage.color, color: stage.color }} />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
